export default "__VITE_ASSET__CGft5soT__"